import { toast } from "react-toastify";
import api from "./api/api";

const GetAllClientes = {
  listClientes: async () => {
    try {
      const res = await api.get("/clientes");
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  consultarCnpj: async (cnpj: string) => {
    try {
      const res = await api.get(`/clientes/consultarCnpj?cnpj=${cnpj}`);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  adicionarClientes: async (payload: any) => {
    try {
      const res = await api.post("/clientes", payload);
      toast.success("Adicionado com sucesso");
      return res;
    } catch (error: any) {
      toast.error(error.response.data.msg);
      return error.response;
    }
  },
  listClientesPagination: async (
    page: any,
    perPage: any,
    findByName: string = "",
    tipoCliente?: any,
  ) => {
    try {
      const res = await api.get(
        `/clientes?page=${page}&perPage=${perPage}&s=${findByName}${
          tipoCliente ? `&type_cliente=${tipoCliente}` : ""
        }`,
      );
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  editarClient: async (payload: any, id: any) => {
    try {
      const res = await api.put(`/clientes/${id}`, payload, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      toast.success("Editado com sucesso");
      return res;
    } catch (error: any) {
      toast.error(error.response.data.msg);
      toast.error("Erro ao Editar Usuário");
      return error.response;
    }
  },
  deleteClient: async (id: any) => {
    try {
      const res = await api.delete(`/clientes/${id}`);
      toast.success("Deletado com sucesso");
      return res;
    } catch (error: any) {
      toast.error(error.response.data.msg);
      toast.error("Erro ao Deletar Usuário");
      return error.response;
    }
  },
  getClientById: async (id: any) => {
    try {
      const res = await api.get(`/clientes/${id}`);
      return res;
    } catch (error: any) {
      toast.error(error.response.data.msg);
      return error.response;
    }
  },
  getRelationsShips: async (userId: any) => {
    try {
      const res = await api.get(`/clientes/${userId}/relationships`);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  importarClientes: async (rows: any[]) => {
    try {
      const res = await api.post("/clientes/import", { rows });
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
};

export default GetAllClientes;
